import PrivacyRecruit from './recruit'

export default PrivacyRecruit
